<template>
  <div class="withdraw-money-wrapper">
    <div class="withdraw-control">
      <h4>提现金额 (元)</h4>
      <div class="withdraw-input"><span>¥</span><number-input class="money-typer" v-model="withdrawMoney"></number-input></div>
      <!-- <div class="money-tip">账户余额:<span class="total-money">5,796.00</span>(元)<span class="all">全部提现</span></div> -->
    </div>
    <div class="withdraw-way">
      <div class="way-title">提现方式</div>
      <div class="way-content">
        <div class="type"><span class="type-icon"><icon icon-class="wechat"></icon></span>提现到微信</div>
        <div class="checked"><icon icon-class="cricle-check"></icon></div>
      </div>
    </div>
    <div class="withdraw-tips">
      <h5>温馨提示：</h5>
      <p>为了确保您的账户金额正常提现，您可在每月的28号进行【申请提现】操作，财务会在3个工作日内统一进行审核，审核通过后您可进入个人账户中查看提现明细。</p>
    </div>
    <div class="withdraw-submit"><button class="submit">提现</button></div>
    <p class="law-tip">根据国家法律，平台将会代扣个人所得税<span @click="moneyRulesShow = true">查看详细计算方法</span></p>
  </div>
</template>

<style lang="less" scoped>
  .withdraw-money-wrapper{
    position: relative;
    min-height: 100vh;
    background: #F7F7F7;
    padding-top: 12px;
    .withdraw-control{
      padding: 24px 20px;
      background: #FFF;
      h4{
        font-size: 14px;
        line-height: 14px;
        color: @black;
        font-weight: normal;
        margin-bottom: 10px;
      }
      .withdraw-input{
        border-bottom: 1px solid #D8D8D8;
        padding: 10px 0;
        font-size: 26px;
        color: @black;
        font-weight: bold;
        display: flex;
        align-items: flex-end;
        .money-typer{
          padding-left: 16px;
          font-size: 32px;
          height: 32px;
          color: @black;
          max-width: 90%;
        }
      }
      .money-tip{
        margin-top: 17px;
        font-size: 12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #999;
        .total-money{
          font-size: 15px;
          margin: 0 2px 0 4px;
        }
        .all{
          margin-left: 12px;
          color: @xile;
        }
      }
    }
    .withdraw-way{
      background: #FFF;
      margin-top: 12px;
      .way-title{
        height: 48px;
        padding: 0 20px;
        font-size: 14px;
        color: @black;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #EEE;
      }
      .way-content{
        height: 74px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .type{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 14px;
          line-height: 14px;
          color: @black;
          .type-icon{
            width: 30px;
            height: 30px;
            background: #6BCC03;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin-right: 9px;
            svg{
              font-size: 24px;
              color: #FFF;
            }
          }
        }
        .checked{
          font-size: 16px;
          svg{
            color: @xile;
          }
        }
      }
    }
    .withdraw-tips{
      padding: 24px 20px 0;
      h5{
        font-size: 13px;
        line-height: 13px;
        margin-bottom: 6px;
        color: #666;
      }
      p{
        font-size: 12px;
        line-height: 16px;
        color: #999;
      }
    }
    .withdraw-submit{
      width: 240px;
      margin: 36px auto 0;
      button{
        @button-base();
        width: 100%;
        height: 36px;
      }
    }
    .law-tip{
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 16px;
      font-size: 12px;
      text-align: center;
      color: #999;
      span{
        margin-left: 6px;
        color: #666;
        text-decoration: underline;
      }
    }
  }
</style>

<script type="text/javascript">
  import numberInput from '@/components/Common/numberInput'
  export default {
    data() {
      return {
        withdrawMoney: null,
        accountMoney: 0,
        moneyRulesShow: false,
        withdrawConfirm: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      numberInput
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Mine/withdrawMoney.vue